// export const getCountryCode = countryValue => {
//   const countryCodeMap = {
//     Afghan: 'AF',
//     Albanian: 'AL',
//     Algerian: 'DZ',
//     Andorran: 'AD',
//     Angolan: 'AO',
//     'Antiguan or Barbudan': 'AG',
//     Argentine: 'AR',
//     Armenian: 'AM',
//     Australian: 'AU',
//     Austrian: 'AT',
//     Azerbaijani: 'AZ',
//     Bahamian: 'BS',
//     Bahraini: 'BH',
//     Bangladeshi: 'BD',
//     Barbadian: 'BB',
//     Belarusian: 'BY',
//     saudi: 'SA',
//     Belgian: 'BE',
//     Belizean: 'BZ',
//     Beninese: 'BJ',
//     Bhutanese: 'BT',
//     Bolivian: 'BO',
//     'Bosnian or Herzegovinian': 'BA',
//     Botswanan: 'BW',
//     Brazilian: 'BR',
//     Bruneian: 'BN',
//     Bulgarian: 'BG',
//     Burkinabé: 'BF',
//     Burundian: 'BI',
//     'Cabo Verdean': 'CV',
//     Cambodian: 'KH',
//     Cameroonian: 'CM',
//     Canadian: 'CA',
//     'Central African': 'CF',
//     Chadian: 'TD',
//     Chilean: 'CL',
//     Chinese: 'CN',
//     Colombian: 'CO',
//     Comorian: 'KM',
//     'Congolese (Congo)': 'CG',
//     'Congolese (DRC)': 'CD',
//     'Costa Rican': 'CR',
//     Croatian: 'HR',
//     Cuban: 'CU',
//     Cypriot: 'CY',
//     Czech: 'CZ',
//     Danish: 'DK',
//     Djiboutian: 'DJ',
//     Dominican: 'DM',
//     'Dominican Republic': 'DO',
//     Ecuadorian: 'EC',
//     Egyptian: 'EG',
//     Salvadoran: 'SV',
//     'Equatorial Guinean': 'GQ',
//     Eritrean: 'ER',
//     Estonian: 'EE',
//     Eswatini: 'SZ',
//     Ethiopian: 'ET',
//     Fijian: 'FJ',
//     Finnish: 'FI',
//     French: 'FR',
//     Gabonese: 'GA',
//     Gambian: 'GM',
//     Georgian: 'GE',
//     German: 'DE',
//     Ghanaian: 'GH',
//     Greek: 'GR',
//     Grenadian: 'GD',
//     Guatemalan: 'GT',
//     Guinean: 'GN',
//     'Bissau-Guinean': 'GW',
//     Guyanese: 'GY',
//     Haitian: 'HT',
//     Honduran: 'HN',
//     Hungarian: 'HU',
//     Icelandic: 'IS',
//     Indian: 'IN',
//     Indonesian: 'ID',
//     Iranian: 'IR',
//     Iraqi: 'IQ',
//     Irish: 'IE',
//     Israeli: 'IL',
//     Italian: 'IT',
//     Jamaican: 'JM',
//     Japanese: 'JP',
//     Jordanian: 'JO',
//     Kazakh: 'KZ',
//     Kenyan: 'KE',
//     Kiribati: 'KI',
//     'North Korean': 'KP',
//     'South Korean': 'KR',
//     Kuwaiti: 'KW',
//     Kyrgyz: 'KG',
//     Lao: 'LA',
//     Latvian: 'LV',
//     Lebanese: 'LB',
//     Basotho: 'LS',
//     Liberian: 'LR',
//     Libyan: 'LY',
//     Liechtenstein: 'LI',
//     Lithuanian: 'LT',
//     Luxembourgish: 'LU',
//     Malagasy: 'MG',
//     Malawian: 'MW',
//     Malaysian: 'MY',
//     Maldivian: 'MV',
//     Malian: 'ML',
//     Maltese: 'MT',
//     Marshallese: 'MH',
//     Mauritanian: 'MR',
//     Mauritian: 'MU',
//     Mexican: 'MX',
//     Micronesian: 'FM',
//     Moldovan: 'MD',
//     Monégasque: 'MC',
//     Mongolian: 'MN',
//     Montenegrin: 'ME',
//     Moroccan: 'MA',
//     Mozambican: 'MZ',
//     Burmese: 'MM',
//     Namibian: 'NA',
//     Nauruan: 'NR',
//     Nepali: 'NP',
//     Dutch: 'NL',
//     'New Zealander': 'NZ',
//     Nicaraguan: 'NI',
//     Nigerien: 'NE',
//     Nigerian: 'NG',
//     Macedonian: 'MK',
//     Norwegian: 'NO',
//     Omani: 'OM',
//     Pakistani: 'PK',
//     Palauan: 'PW',
//     Panamanian: 'PA',
//     'Papua New Guinean': 'PG',
//     Paraguayan: 'PY',
//     Peruvian: 'PE',
//     Filipino: 'PH',
//     Polish: 'PL',
//     Portuguese: 'PT',
//     Palestinian: 'PS',
//     Qatari: 'QA',
//     Romanian: 'RO',
//     Russian: 'RU',
//     Rwandan: 'RW',
//     'Saint Kitts and Nevis': 'KN',
//     'Saint Lucian': 'LC',
//     'Saint Vincentian': 'VC',
//     Samoan: 'WS',
//     'San Marinese': 'SM',
//     'São Toméan': 'ST',
//     Saudi: 'SA',
//     Senegalese: 'SN',
//     Serbian: 'RS',
//     Seychellois: 'SC',
//     'Sierra Leonean': 'SL',
//     Singaporean: 'SG',
//     Slovak: 'SK',
//     Slovene: 'SI',
//     'Solomon Islander': 'SB',
//     Somali: 'SO',
//     'South African': 'ZA',
//     Spanish: 'ES',
//     'Sri Lankan': 'LK',
//     Sudanese: 'SD',
//     Surinamese: 'SR',
//     Swedish: 'SE',
//     Swiss: 'CH',
//     Syrian: 'SY',
//     Taiwanese: 'TW',
//     Tajik: 'TJ',
//     Tanzanian: 'TZ',
//     Thai: 'TH',
//     Timorese: 'TL',
//     Togolese: 'TG',
//     Tongan: 'TO',
//     'Trinidadian or Tobagonian': 'TT',
//     Tunisian: 'TN',
//     Turkish: 'TR',
//     Turkmen: 'TM',
//     Tuvaluan: 'TV',
//     Ugandan: 'UG',
//     Ukrainian: 'UA',
//     Emirati: 'AE',
//     British: 'GB',
//     American: 'US',
//     Uruguayan: 'UY',
//     Uzbek: 'UZ',
//     Vanuatuan: 'VU',
//     Venezuelan: 'VE',
//     Vietnamese: 'VN',
//     Yemeni: 'YE',
//     Zambian: 'ZM',
//     Zimbabwean: 'ZW'
//   }

//   return countryCodeMap[countryValue] || null
// }

export const getCountryCode = (countryValue) => {
  const countryCodeMap = {
    // English values
    Afghan: "AF",
    Albanian: "AL",
    Algerian: "DZ",
    Andorran: "AD",
    Angolan: "AO",
    "Antiguan or Barbudan": "AG",
    Argentine: "AR",
    Armenian: "AM",
    Australian: "AU",
    Austrian: "AT",
    Azerbaijani: "AZ",
    Bahamian: "BS",
    Bahraini: "BH",
    Bangladeshi: "BD",
    Barbadian: "BB",
    Belarusian: "BY",
    Saudi: "SA",
    Belgian: "BE",
    Belizean: "BZ",
    Beninese: "BJ",
    Bhutanese: "BT",
    Bolivian: "BO",
    "Bosnian or Herzegovinian": "BA",
    Botswanan: "BW",
    Brazilian: "BR",
    Bruneian: "BN",
    Bulgarian: "BG",
    Burkinabé: "BF",
    Burundian: "BI",
    "Cabo Verdean": "CV",
    Cambodian: "KH",
    Cameroonian: "CM",
    Canadian: "CA",
    "Central African": "CF",
    Chadian: "TD",
    Chilean: "CL",
    Chinese: "CN",
    Colombian: "CO",
    Comorian: "KM",
    "Congolese (Congo)": "CG",
    "Congolese (DRC)": "CD",
    "Costa Rican": "CR",
    Croatian: "HR",
    Cuban: "CU",
    Cypriot: "CY",
    Czech: "CZ",
    Danish: "DK",
    Djiboutian: "DJ",
    Dominican: "DM",
    "Dominican Republic": "DO",
    Ecuadorian: "EC",
    Egyptian: "EG",
    Salvadoran: "SV",
    "Equatorial Guinean": "GQ",
    Eritrean: "ER",
    Estonian: "EE",
    Eswatini: "SZ",
    Ethiopian: "ET",
    Fijian: "FJ",
    Finnish: "FI",
    French: "FR",
    Gabonese: "GA",
    Gambian: "GM",
    Georgian: "GE",
    German: "DE",
    Ghanaian: "GH",
    Greek: "GR",
    Grenadian: "GD",
    Guatemalan: "GT",
    Guinean: "GN",
    "Bissau-Guinean": "GW",
    Guyanese: "GY",
    Haitian: "HT",
    Honduran: "HN",
    Hungarian: "HU",
    Icelandic: "IS",
    Indian: "IN",
    Indonesian: "ID",
    Iranian: "IR",
    Iraqi: "IQ",
    Irish: "IE",
    Israeli: "IL",
    Italian: "IT",
    Jamaican: "JM",
    Japanese: "JP",
    Jordanian: "JO",
    Kazakh: "KZ",
    Kenyan: "KE",
    Kiribati: "KI",
    "North Korean": "KP",
    "South Korean": "KR",
    Kuwaiti: "KW",
    Kyrgyz: "KG",
    Lao: "LA",
    Latvian: "LV",
    Lebanese: "LB",
    Basotho: "LS",
    Liberian: "LR",
    Libyan: "LY",
    Liechtenstein: "LI",
    Lithuanian: "LT",
    Luxembourgish: "LU",
    Malagasy: "MG",
    Malawian: "MW",
    Malaysian: "MY",
    Maldivian: "MV",
    Malian: "ML",
    Maltese: "MT",
    Marshallese: "MH",
    Mauritanian: "MR",
    Mauritian: "MU",
    Mexican: "MX",
    Micronesian: "FM",
    Moldovan: "MD",
    Monégasque: "MC",
    Mongolian: "MN",
    Montenegrin: "ME",
    Moroccan: "MA",
    Mozambican: "MZ",
    Burmese: "MM",
    Namibian: "NA",
    Nauruan: "NR",
    Nepali: "NP",
    Dutch: "NL",
    "New Zealander": "NZ",
    Nicaraguan: "NI",
    Nigerien: "NE",
    Nigerian: "NG",
    Macedonian: "MK",
    Norwegian: "NO",
    Omani: "OM",
    Pakistani: "PK",
    Palauan: "PW",
    Panamanian: "PA",
    "Papua New Guinean": "PG",
    Paraguayan: "PY",
    Peruvian: "PE",
    Filipino: "PH",
    Polish: "PL",
    Portuguese: "PT",
    Palestinian: "PS",
    Qatari: "QA",
    Romanian: "RO",
    Russian: "RU",
    Rwandan: "RW",
    "Saint Kitts and Nevis": "KN",
    "Saint Lucian": "LC",
    "Saint Vincentian": "VC",
    Samoan: "WS",
    "San Marinese": "SM",
    "São Toméan": "ST",
    Senegalese: "SN",
    Serbian: "RS",
    Seychellois: "SC",
    "Sierra Leonean": "SL",
    Singaporean: "SG",
    Slovak: "SK",
    Slovene: "SI",
    "Solomon Islander": "SB",
    Somali: "SO",
    "South African": "ZA",
    Spanish: "ES",
    "Sri Lankan": "LK",
    Sudanese: "SD",
    Surinamese: "SR",
    Swedish: "SE",
    Swiss: "CH",
    Syrian: "SY",
    Taiwanese: "TW",
    Tajik: "TJ",
    Tanzanian: "TZ",
    Thai: "TH",
    Timorese: "TL",
    Togolese: "TG",
    Tongan: "TO",
    "Trinidadian or Tobagonian": "TT",
    Tunisian: "TN",
    Turkish: "TR",
    Turkmen: "TM",
    Tuvaluan: "TV",
    Ugandan: "UG",
    Ukrainian: "UA",
    Emirati: "AE",
    British: "GB",
    American: "US",
    Uruguayan: "UY",
    Uzbek: "UZ",
    Vanuatuan: "VU",
    Venezuelan: "VE",
    Vietnamese: "VN",
    Yemeni: "YE",
    Zambian: "ZM",
    Zimbabwean: "ZW",

    // Arabic values
    أفغاني: "AF",
    ألباني: "AL",
    جزائري: "DZ",
    أندوري: "AD",
    أنغولي: "AO",
    "أنتيغوا وبربودا": "AG",
    أرجنتيني: "AR",
    أرميني: "AM",
    أسترالي: "AU",
    نمساوي: "AT",
    أذربيجاني: "AZ",
    باهامي: "BS",
    بحريني: "BH",
    بنغلاديشي: "BD",
    بربادوسي: "BB",
    بيلاروسي: "BY",
    سعودي: "SA",
    بلجيكي: "BE",
    بليزي: "BZ",
    بنيني: "BJ",
    بوتاني: "BT",
    بوليفي: "BO",
    "بوسني أو هيرزيغوفيني": "BA",
    بوتسواني: "BW",
    برازيلي: "BR",
    بروناي: "BN",
    بلغاري: "BG",
    بوركيني: "BF",
    بوروندي: "BI",
    "الرأس الأخضر": "CV",
    كمبودي: "KH",
    كاميروني: "CM",
    كندي: "CA",
    "أفريقي مركزي": "CF",
    تشادي: "TD",
    تشيلي: "CL",
    صيني: "CN",
    كولومبي: "CO",
    قُمري: "KM",
    "كونغولي (كونغو)": "CG",
    "كونغولي (جمهورية الكونغو الديمقراطية)": "CD",
    كوستاريكي: "CR",
    كرواتي: "HR",
    كوبي: "CU",
    قبرصي: "CY",
    تشيكي: "CZ",
    دنماركي: "DK",
    جيبوتي: "DJ",
    دومينيكي: "DM",
    "جمهورية الدومينيكان": "DO",
    إكوادوري: "EC",
    مصري: "EG",
    سلفادوري: "SV",
    "غيني استوائي": "GQ",
    إريتري: "ER",
    إستوني: "EE",
    إسواتيني: "SZ",
    إثيوبي: "ET",
    فيجي: "FJ",
    فنلندي: "FI",
    فرنسي: "FR",
    غابوني: "GA",
    غامبي: "GM",
    جورجي: "GE",
    ألماني: "DE",
    غاني: "GH",
    يوناني: "GR",
    غرينادي: "GD",
    غواتيمالي: "GT",
    غيني: "GN",
    "غيني بيساو": "GW",
    غيانا: "GY",
    هايتي: "HT",
    هندوراس: "HN",
    مجري: "HU",
    آيسلندي: "IS",
    هندي: "IN",
    إندونيسي: "ID",
    إيراني: "IR",
    عراقي: "IQ",
    أيرلندي: "IE",
    إسرائيلي: "IL",
    إيطالي: "IT",
    جامايكي: "JM",
    ياباني: "JP",
    أردني: "JO",
    كازاخستاني: "KZ",
    كيني: "KE",
    كيريباتي: "KI",
    "كوري شمالي": "KP",
    "كوري جنوبي": "KR",
    كويتي: "KW",
    قيرغيزستاني: "KG",
    لاوسي: "LA",
    لاتفي: "LV",
    لبناني: "LB",
    ليسوتو: "LS",
    ليبيري: "LR",
    ليبي: "LY",
    ليختنشتاين: "LI",
    ليتواني: "LT",
    لوكسمبورغي: "LU",
    مدغشقري: "MG",
    مالاوي: "MW",
    ماليزي: "MY",
    مالديفي: "MV",
    مالي: "ML",
    مالطي: "MT",
    "جزر مارشال": "MH",
    موريتاني: "MR",
    موريشيوس: "MU",
    مكسيكي: "MX",
    ميكرونيسي: "FM",
    مولدوفي: "MD",
    موناكو: "MC",
    منغولي: "MN",
    "الجبل الأسود": "ME",
    مغربي: "MA",
    موزمبيقي: "MZ",
    ميانماري: "MM",
    ناميبي: "NA",
    ناورو: "NR",
    نيبالي: "NP",
    هولندي: "NL",
    نيوزيلندي: "NZ",
    نيكاراغوا: "NI",
    النيجر: "NE",
    نيجيري: "NG",
    مقدوني: "MK",
    نرويجي: "NO",
    عُماني: "OM",
    باكستاني: "PK",
    بالاو: "PW",
    بنمي: "PA",
    "بابوا غينيا الجديدة": "PG",
    باراغواي: "PY",
    بيروفي: "PE",
    فلبيني: "PH",
    بولندي: "PL",
    برتغالي: "PT",
    فلسطيني: "PS",
    قطري: "QA",
    روماني: "RO",
    روسي: "RU",
    رواندي: "RW",
    "سانت كيتس ونيفيس": "KN",
    "سانت لوسيا": "LC",
    "سانت فنسنت": "VC",
    ساموا: "WS",
    "سان مارينو": "SM",
    "ساو تومي وبرينسيبي": "ST",
    سنغالي: "SN",
    صربي: "RS",
    سيشلي: "SC",
    سيراليوني: "SL",
    سنغافوري: "SG",
    سلوفاكي: "SK",
    سلوفيني: "SI",
    "جزر سليمان": "SB",
    صومالي: "SO",
    "جنوب أفريقي": "ZA",
    إسباني: "ES",
    سريلانكي: "LK",
    سوداني: "SD",
    سورينامي: "SR",
    سويدي: "SE",
    سويسري: "CH",
    سوري: "SY",
    تايواني: "TW",
    طاجيكستاني: "TJ",
    تنزاني: "TZ",
    تايلاندي: "TH",
    تيمور: "TL",
    توغولي: "TG",
    تونغا: "TO",
    "ترينيداد وتوباغو": "TT",
    تونسي: "TN",
    تركي: "TR",
    تركمانستاني: "TM",
    توفالو: "TV",
    أوغندي: "UG",
    أوكراني: "UA",
    إماراتي: "AE",
    بريطاني: "GB",
    أمريكي: "US",
    أوروغواي: "UY",
    أوزبكستاني: "UZ",
    فانواتو: "VU",
    فنزويلي: "VE",
    فيتنامي: "VN",
    يمني: "YE",
    زامبي: "ZM",
    زيمبابوي: "ZW",
  };

  return countryCodeMap[countryValue] || null;
};
